<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator=">">
      <el-breadcrumb-item>Devices</el-breadcrumb-item>
      <el-breadcrumb-item>激活设备清单</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>

    <div class="container">


      <el-radio-group v-model="bikeType" style="margin-right: 20px; " size="medium">
        <el-radio-button label="pad">pad</el-radio-button>
        <el-radio-button label="app">app</el-radio-button>
        <el-radio-button label="all">all</el-radio-button>
        <el-radio-button label="xbike">xbike</el-radio-button>
        <el-radio-button label="litbike">litbike</el-radio-button>
        <el-radio-button label="boombike">boombike</el-radio-button>
        <el-radio-button label="boombasic">boombasic</el-radio-button>
        <el-radio-button label="ebike">ebike</el-radio-button>
        <el-radio-button label="other">other</el-radio-button>
      </el-radio-group>

    </div>

    <!-- 表格 -->
    <el-table :data="tableData" stripe style="width: 100%" height="750"  :default-sort="{ prop: 'id', order: 'descending' }">
      <el-table-column prop="id" label="序号" width="120"   sortable></el-table-column>
      <el-table-column prop="deviceNumber" label="设备" width="220">

    <template slot-scope="scope">
      <!-- 这里使用 a 标签实现点击，也可以使用 div 或其他标签，并通过样式调整显示 -->
      <a href="javascript:;" @click="openInNewTab(scope.row.deviceNumber)"> {{ scope.row.deviceNumber }} </a>
    </template>

  </el-table-column>
      <el-table-column prop="keyUser" label="主账号" width="180"></el-table-column>
      <el-table-column prop="type" label="车型" width="110"></el-table-column>
      <el-table-column prop="activateDate" label="激活日期"sortable> </el-table-column>
      <el-table-column prop="cardDate" label="绑卡日期"sortable>  </el-table-column>
      <el-table-column prop="trialDate" label="试用日期"sortable> </el-table-column>
      <el-table-column prop="subsDate" label="首次付费日期"sortable> </el-table-column> 
      <el-table-column prop="status" label="当前状态"></el-table-column> 
    </el-table>

    <!-- 分页 -->
    <el-pagination @current-change="handleCurrentChange" :current-page="pagination.currentPage" :page-sizes="[20, 50, 100]" :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalDevices" @size-change="handleSizeChange">
    </el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      totalDevices: 0,
      pagination: {
        currentPage: 1,
        pageSize: 20
      },

        bikeType: 'pad'

    }
  },

  watch: {


    bikeType(newVal, oldVal) {

      this.pagination.currentPage= 1
    
      this.fetchTableData(this.pagination.currentPage, this.pagination.pageSize,  this.bikeType);
    },
  },


  methods: {
    fetchTableData(page, size, bikeType) {
      const params = {
        page,
        size,
        bike_type: bikeType
      };
      this.$http.get("/da/devices", { params }).then(response => {
        this.tableData = response.data.records;
        this.totalDevices = response.data.total;
      });
    },
    handleSizeChange(newSize) {
      this.pagination.pageSize = newSize;
      this.pagination.currentPage = 1; // 重置为第一页
      this.fetchTableData(this.pagination.currentPage, this.pagination.pageSize, this.bikeType);
    },
    handleCurrentChange(newPage) {
      this.pagination.currentPage = newPage;
      this.fetchTableData(this.pagination.currentPage, this.pagination.pageSize, this.bikeType);
    },
    handleFilterChange() {
      // 筛选条件改变时，重置分页并重新加载数据
      this.pagination.currentPage = 1;
      this.fetchTableData(this.pagination.currentPage, this.pagination.pageSize,  this.bikeType);
    },
    openInNewTab(deviceNumber) {
    // 根据 deviceNumber 确定要打开的URL，这里只是一个示例
      // 使用 location.hostname 动态获取当前环境的主机名
      const host = location.hostname;
    // 假设端口和路径在所有环境下都是一致的
    const port = ':8081';
    const path = '/#/deviceInfo';
    // 构建完整的URL
    const url = `http://${host}${port}${path}?deviceNumber=${deviceNumber}`;

    
    window.open(url, '_blank'); // 在新窗口中打开链接
  },
  },
  created() {
    // 初始化时加载第一页的数据
    this.fetchTableData(this.pagination.currentPage, this.pagination.pageSize,  this.bikeType);
  }
}
</script>
  
<style scoped>
.container {

  display: flex;
  justify-content: flex-end;
  width: 100%;

  margin-bottom: 20px;
}
</style>